document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('.finder-section');
  if(!section)return;
  const snow=section.querySelector('[data-finder="snow"]');
  const wipers=section.querySelector('[data-finder="wipers"]');
  const copy=JSON.parse(section.querySelector('[data-finder-copy]').textContent);
  let kind='chains',vehicle='tourism',fitments=null;
  fetch(section.dataset.fitments).then(r=>r.json()).then(data=>fitments=data).catch(()=>fitments={chains:{},covers:{},covers4x4:{}});
  section.querySelectorAll('[data-open-finder]').forEach(button=>button.addEventListener('click',()=>{
    kind=button.dataset.openFinder;
    if(kind==='wipers'){wipers.showModal();return;}
    snow.querySelector('[data-finder-title]').textContent=kind==='chains'?copy.chainTitle:copy.coverTitle;
    snow.showModal();
  }));
  section.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
  section.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()}));
  section.querySelectorAll('[data-vehicle]').forEach(button=>button.addEventListener('click',()=>{
    vehicle=button.dataset.vehicle;
    section.querySelectorAll('[data-vehicle]').forEach(x=>x.classList.toggle('active',x===button));
    section.querySelector('.special-field').hidden=vehicle!=='4x4';
  }));
  section.querySelector('[data-find-snow]').addEventListener('click',()=>{
    const out=snow.querySelector('.finder-results');
    const special=snow.querySelector('[data-special]').value.trim().toUpperCase();
    const values=[...snow.querySelectorAll('[data-tyre]')].map(x=>x.value.replace(/\D/g,''));
    const key=special||`${values[0]}/${values[1]} R${values[2]}`;
    const table=kind==='chains'?(vehicle==='4x4'?{}:fitments?.chains||{}):(vehicle==='4x4'?fitments?.covers4x4||{}:fitments?.covers||{});
    const sizes=table[key]||[];
    out.innerHTML=sizes.length?sizes.map(size=>`<a class="finder-result" href="/search?q=${encodeURIComponent((kind==='chains'?'CADENA METÁLICA':'FUNDA TEXTIL')+' TALLA '+Number(size))}"><span>✓ ${copy.available}</span><strong>${kind==='chains'?copy.chains:copy.covers} · ${copy.size} ${Number(size)}</strong></a>`).join(''):`<div class="finder-result error">${copy.noFit}</div>`;
  });
  section.querySelectorAll('[data-wiper-size]').forEach(button=>button.addEventListener('click',()=>wipers.querySelector('[data-wiper]').value=button.dataset.wiperSize));
  section.querySelector('[data-find-wiper]').addEventListener('click',()=>{
    const value=wipers.querySelector('[data-wiper]').value.replace(/\D/g,'');
    const sizes=['40','43','45','48','50','53','55','58','60','65','70'];
    wipers.querySelector('.finder-results').innerHTML=sizes.includes(value)?`<a class="finder-result" href="/search?q=${encodeURIComponent('ESCOBILLA GOMA FLEXIBLE '+value+' CMS CARPRISS')}"><span>✓ ${copy.available}</span><strong>${value} cm</strong></a>`:`<div class="finder-result error">${copy.wiperNo}</div>`;
  });
});
